<template>
  <div id="header" :class="[dark ? 'dark' : 'white']">
    <div class="header-nav">
      <icon-svg class="icon-logo" @click.native="logoClick" :name="`logo-${iconSuffix}`"></icon-svg>
      <div v-show="showTextLabel" class="title-label">
        <icon-svg class="title-label-bg" name="blue-label"></icon-svg>
        <span class="title-label-text">{{ labelText }}</span>
      </div>
    </div>

    <div class="header-nav">
      <icon-svg class="icon" :name="`user-${iconSuffix}`" @click.native="routePush('/mine')"></icon-svg>
      <icon-svg class="icon" :name="`bars-${iconSuffix}`" @click.native="showPopup()"></icon-svg>
    </div>

    <van-popup v-model="popupVisible" position="top" class="popup" closeable round :close-on-click-overlay="true" :close-on-popstate="true" @click="clickPopup">
      <div class="popup-header">
        <icon-svg class="icon-logo" name="logo-dark"></icon-svg>
      </div>
      <div class="divider" />
      <div class="popup-menu-list">
        <router-link class="menu-item" to="/job/list/social">社会招聘</router-link>
        <router-link class="menu-item" to="/job/list/campus">校园招聘</router-link>
        <router-link class="menu-item" to="/schedule/list">校招行程</router-link>
        <router-link class="menu-item" to="/mine">个人中心</router-link>
        <router-link class="menu-item" to="/resume">我的简历</router-link>
        <router-link class="menu-item" to="/submit_record">投递记录</router-link>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Header",
  props: {
    dark: {
      type: Boolean,
      defalt: false,
    },
    showTextLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popupVisible: false,
    };
  },
  computed: {
    ...mapState("header", ["labelText"]),
    iconSuffix() {
      return this.dark ? "white" : "dark";
    },
  },
  methods: {
    showPopup() {
      this.popupVisible = true;
    },
    clickPopup() {
      this.popupVisible = false;
    },
    routePush(path) {
      if (this.$route.path === path) return;
      this.$router.push({ path: path });
    },
    logoClick() {
      if (this.$route.path === '/job/list/social') return;
      this.$router.push({ path: '/job/list/social' });
    }
  },
};
</script>

<style scoped>
#header {
  /* width: 100%; */
  display: flex;
  padding: 0 10px 0 15px;
  justify-content: space-between;
  align-items: center;
  background-color: #2e5dd2;
  height: 50px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
}

#header.white {
  background-color: white;
}

.header-nav {
  display: flex;
  align-items: center;
  color: white;
  font-size: 16px;
}

.white .header-nav {
  color: #2e5dd2;
}

.icon-logo {
  height: 24px;
  width: 80px;
  margin-right: 8px;
}

.title-label {
  width: 57px;
  height: 21px;
  font-size: 11px;
  color: #ffffff;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: cetner;
}

.title-label-bg {
  width: 100%;
  height: 100%;
}

.title-label-text {
  width: 100%;
  margin-left: -57px;
  margin-top: -2px;
}

.white .header-nav {
  color: #00a1d6;
}

.icon {
  width: 32px;
  height: 32px;
  margin-left: 3px;
}

.popup-header {
  height: 50px;
  padding: 0 15px;
  display: flex;
  align-items: center;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: grey;
  opacity: 0.15;
}
.popup-menu-list {
  font-size: 16px;
  padding-bottom: 20px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 40px;
  color: black;
}

.router-link-active {
  color: #2e5dd2;
  font-weight: bold;
}
</style>
